export const HEADING_PREVIEW_TEXT = 'Heading';
export const PARAGRAPH_PREVIEW_TEXT =
  'This is a paragraph. Describe the product listing the direct benefits that it will bring to the buyer.';
